import {useEffect, useReducer} from "react";

const useHeadersState = ({rows, isEditing=false}) => {

    const [headers, dispatcher] = useReducer((state, action) => {
        switch (action.type) {
            case 'setHeader':
                return {
                    ...state,
                    [action.payload.key]: action.payload.value
                }
            case 'resetHeader':
                // if the header is not present, do nothing
                if (!state[action.payload.key]) return state;
                const {[action.payload.key]: _, ...newState} = state;
                return newState;
            case 'resetHeaders':
                return {};
            default:
                return state;
        }
    }, {});

    useEffect(() => {
        dispatcher({type: 'resetHeaders'});
    }, [rows, isEditing]);

    const setHeader = (key, value) => dispatcher({type: 'setHeader', payload: {key, value}});
    const resetHeader = (key) => dispatcher({type: 'resetHeader', payload: {key}});
    const resetHeaders = () => dispatcher({type: 'resetHeaders'});

    return {headers, setHeader, resetHeader, resetHeaders};
}

export default useHeadersState;